import { MODULES, MODULE_ORDER } from "@/lib/modules";

// Kolejność i etykiety grup menu (w tym grupa własna + pozycje luźne na górze).
export const GROUP_META = [
  { id: "_top", label: "Góra (luźne)" },
  { id: "infra", label: "Infrastruktura" },
  { id: "devices", label: "Urządzenia" },
  { id: "subscribers", label: "Abonenci" },
  { id: "fiber", label: "Sieć światłowodowa" },
  { id: "io", label: "Import / Eksport" },
  { id: "management", label: "Zarządzanie" },
  { id: "system", label: "System" },
  { id: "custom", label: "Moje skróty" },
];

// Domyślne przypisanie modułów do grup (klucz modułu -> grupa).
const GKEYS = {
  infra: ["poles", "routes", "ducts", "wells", "microducts", "pipelines", "coverage", "zones"],
  devices: ["olt", "olt_cards", "onu", "odf", "patchpanels"],
  subscribers: ["clients", "client_cables"],
  fiber: ["cables", "cable_slack", "closures", "splitters", "splices"],
};
const GACTIONS = { devices: ["snmp", "ping"], fiber: ["connections", "reservations", "qrlabels", "otdrfiles"], io: ["export"] };
export const ACTION_LABELS = { snmp: "Monitoring", ping: "Ping", connections: "Połączenia", reservations: "Rezerwacje", qrlabels: "Etykiety QR", otdrfiles: "Pomiary OTDR", export: "Eksport" };

// Pozycje spoza modułów (Zarządzanie / System). gate: 'nr'=nie odczyt, 'admin'=tylko admin.
export const EXTRA_ITEMS = [
  { id: "warehouse", label: "Magazyn", dg: "management" },
  { id: "dashboard", label: "Pulpit NOC", dg: "management", gate: "nr" },
  { id: "client360", label: "Widok 360°", dg: "management" },
  { id: "routers", label: "Routery", dg: "management", gate: "nr" },
  { id: "switches", label: "Switche", dg: "management", gate: "nr" },
  { id: "wifi", label: "Sieć WiFi", dg: "_top", gate: "nr" },
  { id: "stats", label: "Statystyki", dg: "management", gate: "nr" },
  { id: "users", label: "Pracownicy", dg: "management", gate: "admin" },
  { id: "requests", label: "Wnioski / Aneksy", dg: "management", gate: "admin" },
  { id: "invoices", label: "Faktury", dg: "management", gate: "admin" },
  { id: "schedule", label: "Terminarz", dg: "system", gate: "nr" },
  { id: "ai", label: "Asystent AI", dg: "system", gate: "nr" },
  { id: "settings", label: "Ustawienia", dg: "system" },
  { id: "licenses", label: "Licencje", dg: "system", gate: "master" },
  { id: "security", label: "Bezpieczeństwo", dg: "system", gate: "admin" },
  { id: "pituke", label: "PIT / UKE", dg: "system" },
  { id: "sidusis", label: "SIDUSIS (internet.gov.pl)", dg: "system" },
  { id: "autoplan", label: "Auto-projektant FTTH", dg: "system" },
  { id: "help", label: "Pomoc", dg: "system", gate: "nr" },
];

const GROUPED = new Set(Object.values(GKEYS).flat());

// Zwraca listę wszystkich dostępnych pozycji menu: [{id, label, dg}].
export function buildMenuModel(t, { restricted = false, admin = false, master = false } = {}) {
  const main = (restricted ? ["clients"] : MODULE_ORDER).filter((k) => MODULES[k]);
  const items = [];
  Object.entries(GKEYS).forEach(([g, keys]) => keys.filter((k) => main.includes(k)).forEach((k) => items.push({ id: k, label: t(MODULES[k].label), dg: g })));
  if (!restricted) Object.entries(GACTIONS).forEach(([g, acts]) => acts.forEach((a) => items.push({ id: a, label: t(ACTION_LABELS[a]), dg: g })));
  main.filter((k) => !GROUPED.has(k)).forEach((k) => items.push({ id: k, label: t(MODULES[k].label), dg: "_top" }));
  EXTRA_ITEMS.forEach((e) => {
    if (e.gate === "admin" && !admin) return;
    if (e.gate === "nr" && restricted) return;
    if (e.gate === "master" && !master) return;
    items.push({ id: e.id, label: t(e.label), dg: e.dg });
  });
  return items;
}
